import { useState } from "react";
import { BASE_API } from '../api/Globals';
import { helpHttp } from "../helpers/helpHttp";

export const useFormRestorePassword = (initialForm, validateForm) => {
	const [form, setForm] = useState(initialForm);
	const [errors, setErrors] = useState({});
	const [loading, setLoading] = useState(false);
	const [response, setResponse] = useState(null);

	const handleChange = (e) => {
		const { name, value } = e.target;

		setForm({
			...form,
			[name]: value,
		});
	};

	const handleBlur = (e) => {
		handleChange(e);
		setErrors(validateForm(form));
	};

	const handleLogin = (e) => {
		e.preventDefault();
		setErrors(validateForm(form));
		console.log(Object.keys(errors).length);
		if (Object.keys(errors).length === 0) {

			const arrUser = {
				correo_electronico: form.correo_electronico,
				password: form.contraseña
			};

			setLoading(true);
			
			helpHttp().post(`${BASE_API}auth/recover_password`, {
					body: arrUser,
					headers: {
						"Content-Type": "application/json; charset=utf-8",
						"Accept": "application/json",
						'Access-Control-Allow-Origin': '*'
					},
				})
				.then((res) => {
					if(res.response === 'on') {
						window.location.href = "/#/correo-confirmacion";
					} else if(res.response === 'off') {
						
						setLoading(false);
					
						setForm(initialForm);
						setResponse(res.message);
					}
				});
		}  else {
			return;
		}
	};

	return {
		form,
		errors,
		loading,
		response,
		handleChange,
		handleBlur,
		handleLogin
	};
};